import { groupBy, map, uniq } from 'lodash';

import { GroupId } from '../typings/groups';
import {
    KeywordsData,
    KeywordsEditorBodyView,
    KeywordsEditorData,
    KeywordsEditorsState
} from '../typings/keywordsEditorData';

import { mapPhraseWithMinusWordsToString } from './PhrasesHelpers/PhrasesHelpers';

const KEYWORDS_EDITOR_INITIAL_DATA = {
    input: '',
    isOpen: false,
    value: [],
    errors: [],
    isStatLoading: true,
    keywordStats: [],
    selectedTabIndex: 0,
    view: KeywordsEditorBodyView.short
};

export const getKeywordsEditorInitialData = (): KeywordsEditorData => KEYWORDS_EDITOR_INITIAL_DATA;

const KEYWORDS_EDITOR_INITIAL_STATE: KeywordsEditorsState = {
    editors: {}
};

export const getKeywordsEditorInitialState = (): KeywordsEditorsState => KEYWORDS_EDITOR_INITIAL_STATE;

export const getGroupKeywordsEditorId = (groupId: GroupId): string => `group-keywords-editor-${groupId}`;

export const getUniqKeywordsData = (
    actualListKeywords: KeywordsData[],
    keywordsData: KeywordsData[]
): KeywordsData[] => {
    const matchingKeyPhraseToIdHash = actualListKeywords.reduce((acc, itemKeyword) => {
        if (itemKeyword.id && itemKeyword.phrase) {
            acc[itemKeyword.phrase] = itemKeyword.id;
        }

        return acc;
    }, {});

    const listKeywords = groupBy(keywordsData, 'phrase');

    return map(listKeywords, (keywordData, keyword) => {
        return {
            id: matchingKeyPhraseToIdHash[keyword],
            phrase: keyword,
            minusWords: uniq(keywordData.reduce((res, { minusWords }) => [...res, ...minusWords], []))
        };
    });
};

export const getUniqJoinedKeywordsData = (
    actualListKeywords: KeywordsData[],
    keywordsData: KeywordsData[]
): KeywordsData[] => {
    return getUniqKeywordsData(actualListKeywords, [...actualListKeywords, ...keywordsData]);
};

export const parsePhrasesFromInputString = (inputValue: string): KeywordsData[] => {
    return parsePhrasesFromStringList(inputValue.split(/[,\n]/));
};

export const parsePhrasesFromStringList = (keywords: string[]): KeywordsData[] => {
    return keywords.reduce((res: KeywordsData[], phraseString: string) => {
        const trimmedPhrase = phraseString.trim();

        if (trimmedPhrase !== '') {
            res.push(parseKeywordString(trimmedPhrase));
        }

        return res;
    }, []);
};

export const getInputStringFromPhrasesList = (keywordsData: KeywordsData[], view: KeywordsEditorBodyView): string => {
    const delimiter = view === KeywordsEditorBodyView.short ? '\n' : ', ';

    return keywordsData
        .map(({ phrase, minusWords }) => {
            return mapPhraseWithMinusWordsToString(phrase, minusWords);
        })
        .join(delimiter);
};

export const parseKeywordString = (keyword: string): KeywordsData => {
    const [phrase, ...minusWords] = keyword.split(' -');

    return {
        phrase,
        minusWords: minusWords.map(word => word.trim())
    };
};
